export default "__VITE_ASSET__DzOIn5uC__"